import { Button, Form, List, Field, Cell, CellGroup, Step, Steps, Space,
     NavBar, NoticeBar, Tab, Tabs, 
     RadioGroup, Radio,
     DatePicker,Progress,Uploader,Divider,Rate,Card,Tag,Col,Row,TextEllipsis,
     Checkbox,CheckboxGroup,Sticky,Image as VanImage,
     Popup,Overlay,Icon,ConfigProvider,Grid,GridItem,
     SubmitBar,ContactCard,Slider,ActionSheet,Toast,Dialog,FloatingBubble,Sidebar,SidebarItem,Pagination,FloatingPanel,Calendar,
     Picker} from 'vant';
import 'vant/lib/index.css';
export function vant(app) {
    app.use(Button);
    app.use(Field);
    app.use(List);
    app.use(Form);
    app.use(Cell);
    app.use(Step);
    app.use(Steps);
    app.use(CellGroup);
    app.use(Space);
    app.use(NavBar);
    app.use(NoticeBar);
    app.use(Tab);
    app.use(Tabs);
    app.use(RadioGroup);
    app.use(Radio);
    app.use(DatePicker);
    app.use(Progress);
    app.use(Uploader);
    app.use(Divider);
    app.use(Rate);
    app.use(Card);
    app.use(Tag);
    app.use(Col);
    app.use(Row);
    app.use(TextEllipsis);
    app.use(Checkbox);
    app.use(CheckboxGroup);
    app.use(Sticky);
    app.use(VanImage);
    app.use(Popup);
    app.use(Overlay);
    app.use(Icon);
    app.use(ConfigProvider);
    app.use(Grid);
    app.use(GridItem);
    app.use(SubmitBar);
    app.use(ContactCard);
    app.use(Slider);
    app.use(ActionSheet);
    app.use(Toast);
    app.use(Dialog);
    app.use(FloatingBubble);
    app.use(Sidebar);
    app.use(SidebarItem);
    app.use(Pagination);
    app.use(FloatingPanel);
    app.use(Calendar);
    app.use(Picker);
}